import React, { useEffect, useState } from 'react';

import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import { TopBarContainer } from './css';
import request from '../../../../utils/request';

import Filter from './components/filter';
import Block from './components/block';

const Channels = () => {
  const [apiData, setApiData] = useState();
  const [filterString, setFilterString] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/channels/?type=1');

      if (result && result.status === 200) {
        setApiData(result.data.channels);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <div className='layout-container'>
      <DimpleDivider />
      {!apiData && <Spinner spinning label="Loading data..." />}
      {apiData && (
        <>
          <TopBarContainer>
            <Filter
              filterString={filterString}
              setFilterString={setFilterString}
            />
          </TopBarContainer>
          <DimpleDivider />
          <Block
            data={apiData}
            filterString={filterString}
            fetchData={fetchData}
          />
        </>
      )}
      </div>
    </>
  );
};

export default Channels;
